import { useEffect, useState } from 'react'
import { getLocationDataFromResult } from 'common/Footer/helpers'
import styles from './index.module.scss'
import HeaderFilterButton from 'app/SeFriendly/SeFriendlyProviderSearch/HeaderFilterButton'
import LocationAutoComplete from './LocationAutoComplete'
import { useRouter } from 'next/router'
import useBreakpoint from 'hooks/useBreakPoint'
import { ProviderHeaderFilterTypes } from 'dataSource/ProviderSearch'
import { filterTitle } from 'constants/common'
import classNames from 'classnames'

type LocationFilterProps = {
  setHideOtherFilters: (hideOtherFilters: boolean) => void
  containerClassName?: string
  onFilterSelect: (selectedFilter: Record<string, unknown>) => void
}

const LocationFilter: React.FC<LocationFilterProps> = ({
  setHideOtherFilters,
  containerClassName = '',
  onFilterSelect,
}) => {
  const router = useRouter()
  const [showDropdown, setShowDropdown] = useState<boolean>()
  const [locationData, setLocationData] = useState<ChangeLocationFormProps>({
    location: '',
    state: '',
    latitude: '',
    longitude: '',
  })
  const [fullStateName, setFullStateName] = useState<string>('')
  const { isMobileScreen } = useBreakpoint()

  useEffect(() => {
    const { query } = router
    const location = (query.location as string) || ''
    const fullStateName = location.split(',')[0]
    setFullStateName(fullStateName)
    setLocationData({
      ...locationData,
      location,
    })
  }, [router.query])

  const onSelectLocation = (result: GoogleLocationResult) => {
    const { state, latitude, longitude, location } = getLocationDataFromResult(
      result
    )

    if (!!state && !!latitude && !!longitude && !!location) {
      // The state given by getLocationDataFromResult is a shorter version. eg: state[]
      const fullStateName = location.split(',')[0]
      const locationData = {
        location,
        state,
        longitude,
        latitude,
      }
      setFullStateName(fullStateName)
      setLocationData(locationData)
      setShowDropdown(false)
      setHideOtherFilters(false)
      onFilterSelect(locationData)
    }
  }

  return (
    <HeaderFilterButton
      title={filterTitle.LOCATION}
      showButton={!showDropdown}
      showDropdown={showDropdown}
      filterType={ProviderHeaderFilterTypes.LOCATION}
      setShowDropdown={(value) => {
        setHideOtherFilters(value)
        setShowDropdown(value)
      }}
      buttonClassName={[styles.location_filter_button, 'form-search location']}
      placeHolder={filterTitle.LOCATION}
      mobilePlaceHolder={filterTitle.LOCATION}
      text={isMobileScreen ? fullStateName : locationData.location}
      containerClassName={containerClassName}
      type="location"
    >
      <LocationAutoComplete
        prefillInputValue={locationData.location}
        onSelect={onSelectLocation}
        inputClassName="pl-4 bg-transparent flex-grow-1"
        containerClassName="flex-grow-1"
        suggestionItemClassName={styles.new_location_suggestion_item}
        suggestionContainerClassName={classNames(
          'mt-5',
          styles.new_suggestion_container
        )}
      />
    </HeaderFilterButton>
  )
}

export default LocationFilter
